import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './UserIcon.module.scss';

export interface UserIconProps {
    border?: boolean;
    numNotifications?: number;
    size?: 'small' | 'medium' | 'large';
    iconUrl: string | null;
    onClick?: () => void;
    ariaLabel?: string;
}

const fallbackIcon = '/img/user.png';

export const UserIcon = ({
    border = false,
    numNotifications = 0,
    size = 'small',
    iconUrl = fallbackIcon,
    onClick,
    ariaLabel,
}: UserIconProps) => {
    const { t } = useTranslation();
    
    const dynamicIconStyles = {
        backgroundImage: `url(${iconUrl}), url(${fallbackIcon})`,
        border: border ? '1px solid #FFF' : 'none',
    };
    
    const iconContent = (
        <>
            {numNotifications ? (
                <span className={styles.badge} aria-label={t('Notifications.Count', { count: numNotifications, defaultValue: `${numNotifications} notifications` })}>
                    {numNotifications}
                </span>
            ) : null}
        </>
    );
    
    if (onClick) {
        return (
            <div className={styles.iconContainer}>
                <button
                    type="button"
                    className={`${styles.icon} ${styles[size]} ${styles.clickable}`}
                    style={dynamicIconStyles}
                    onClick={onClick}
                    aria-label={ariaLabel || t('User.EditProfilePicture', 'Edit profile picture')}
                >
                    {iconContent}
                </button>
                <span className={styles.editIcon} aria-hidden="true">
                    <i className={'far fa-edit'} />
                </span>
            </div>
        );
    }
    
    return (
        <div className={styles.iconContainer}>
            <div
                className={`${styles.icon} ${styles[size]}`}
                style={dynamicIconStyles}
                role="img"
                aria-label={ariaLabel || t('User.ProfilePicture', 'Profile picture')}
            >
                {iconContent}
            </div>
        </div>
    );
};
